export const updateMontant = {
    methods: {
        updateMontant(valeur, nbDecimal){    
            if (!nbDecimal){nbDecimal = 0} //Si je n'ai pas précisé de valeur pour nbDécimal, c'est que c'est 0 décimales

            if (valeur != undefined){
                //Supprimer les espaces et remplacer les virgules par des points
                if (isNaN(valeur) && typeof valeur == 'string'){
                    valeur = valeur.replace(/\s/g, '');
                    valeur = (valeur).replace(",",".");
                    valeur = parseFloat(valeur)
                }

                //Vérifier que la nouvelle valeur est bien un nombre
                if (valeur  &&  !isNaN(valeur)){
                    //La nouvelle valeur est validée, j'en fait un valeur numérique
                    let valeurNUM = parseFloat(valeur)
                    //Et une valeur String avec des séparateurs de milliers
                    let valeurSTR = (Math.round(valeur * Math.pow(10, nbDecimal)) / Math.pow(10, nbDecimal)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
                    return {num: valeurNUM, str: valeurSTR}
                } else if (valeur == 0){ //VALEUR RENVOYEE SI = 0
                    return  {num: 0, str: "000"};
                } else {
                    return false //VALEUR RENVOYEE SI pas un nombre
                }
            } else {
                return {num: 0, str: "-"}; //VALEUR RENVOYEE SI UNDEFINED
            }
        }
    }
}